import { BuildType } from '../../enums/build/build-type';

import type { Colors } from './colors';
import { getColors } from './colors';
import type { CommonStyle } from './common';
import { getCommon } from './common';
import type { Fonts } from './fonts';
import { getFonts } from './fonts';
import type { Forms } from './forms';
import { getLegacyForms } from './forms';
import type { Logos } from './logos';
import { getLogos } from './logos';
import type { TextStyles } from './text-styles';
import { getTextStyles } from './text-styles';

export type Styling = {
  colors: Colors;
  common: CommonStyle;
  logos: Logos;
  legacyForms: Forms;
  fonts: Fonts;
  texts: TextStyles;
};

export const getStyling = (buildType: BuildType): Styling => {
  const colors = getColors(buildType);
  const fonts = getFonts(buildType);
  const common = getCommon(buildType, colors, fonts);
  const logos = getLogos(buildType);
  const legacyForms = getLegacyForms(buildType, colors, fonts);
  const texts = getTextStyles(buildType);

  return {
    colors,
    common,
    logos,
    legacyForms,
    fonts,
    texts,
  };
};

export const defaultStyling = getStyling(BuildType.DAVID_LLOYD_UK);
